"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "settings.units",
    path: "units",
    component: "UnitsEditor"
});
let UnitsEditor = class UnitsEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    unitTypes;
    async $$load_unitTypes() {
        return this.$fn.getEnumValuesFromSchema('UnitTypes');
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_unit');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_3343864469950044_columns;
    async $$load_b_3343864469950044_columns() {
        return [{
                name: "unit_type",
                type: "select",
                header: this.$fn.pgettext("Unit", "Type"),
                width: "200px",
                required: true,
                options: this.unitTypes,
                valueField: "value",
                textField: "text",
            },
            {
                name: "symbol",
                header: this.$fn.pgettext("Unit", "Symbol"),
                width: "150px",
                required: true,
            },
            {
                name: "name",
                header: this.$fn.pgettext("Unit", "Name"),
                width: "200px",
                required: true,
            },
            {
                name: "description",
                header: this.$fn.pgettext("Unit", "Description"),
                width: "250px",
            },
        ];
    }
    dataMembers = ['unitTypes', 'items', 'ux', 'b_7315092382398562_modalBindings', 'b_3343864469950044_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                unitTypes: null,
                items: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_3343864469950044_columns: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_7315092382398562_closeModal_5692_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3343864469950044_script_5696_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('unit').upsert({ ...$event.data.row }));
    }
    async act_3343864469950044_script_5696_getActionArgs($event) {
        return {
            value: () => this.act_3343864469950044_script_5696_getActionArgs_value($event),
        };
    }
    async evh_3343864469950044_save(event, scope) {
        return await this.actions.evh_3343864469950044_save.executeFromDOM(this, event, scope);
    }
    async act_3343864469950044_script_5698_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('unit').delete({ ...$event.data.row }));
    }
    async act_3343864469950044_script_5698_getActionArgs($event) {
        return {
            value: () => this.act_3343864469950044_script_5698_getActionArgs_value($event),
        };
    }
    async evh_3343864469950044_delete(event, scope) {
        return await this.actions.evh_3343864469950044_delete.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5692 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5692_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5691 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5692,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5691],
        });
        const act_8320016629450276_reloadComponentData_5694 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_8320016629450276_clickPreventStop_5693 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadComponentData_5694,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_5693],
        });
        const act_3343864469950044_script_5696 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3343864469950044_script_5696_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_save_5695 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_script_5696,
            event: "save",
            displayName: "script",
        });
        const evh_3343864469950044_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_save_5695],
        });
        const act_3343864469950044_script_5698 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3343864469950044_script_5698_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_delete_5697 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_script_5698,
            event: "delete",
            displayName: "script",
        });
        const evh_3343864469950044_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_delete_5697],
        });
        return {
            act_7315092382398562_closeModal_5692,
            evh_7315092382398562_close_5691,
            evh_7315092382398562_close,
            act_8320016629450276_reloadComponentData_5694,
            evh_8320016629450276_clickPreventStop_5693,
            evh_8320016629450276_clickPreventStop,
            act_3343864469950044_script_5696,
            evh_3343864469950044_save_5695,
            evh_3343864469950044_save,
            act_3343864469950044_script_5698,
            evh_3343864469950044_delete_5697,
            evh_3343864469950044_delete,
            reload: act_8320016629450276_reloadComponentData_5694,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], UnitsEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UnitsEditor.prototype, "onSize", null);
UnitsEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], UnitsEditor);
exports.default = UnitsEditor;
vue_property_decorator_1.Vue.component("UnitsEditor", UnitsEditor);
